import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 327px;
  position: absolute;
  bottom: 0px;
  z-index: 105;
`;

export const HelpContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #0e1318;
  padding: 15px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  .help-icon {
    width: 75px;
    margin-top: -10px;
    margin-right: 20px;
  }
  .help-text-details {
    display: flex;
    flex-direction: column;
  }
  .ideation-icon {
    width: 15px;
  }
  .ideation-txt {
    font-size: 12px;
    color: #FFFFFF;
  }
`;
